import { OrderDetail, OrderEventModify, OrderTerm } from 'api'
import { Translation } from 'locale'
import { isNil } from 'lodash'
import { NotificationType } from 'store/notification'
import { isNotNil } from 'utils/predicate'
import { v4 as uuidv4 } from 'uuid'

export const createMapOrderDataToOrderEventModify = (startDate: Date | null, endDate: Date | null, term: OrderTerm | null) => (
  orderDetail: OrderDetail
): OrderEventModify => {
  const { order } = orderDetail
  return {
    ...order,
    startDate,
    endDate,
    term: deriveDefaultTerm(startDate, endDate, term),
    eventType: 'OrderEventModify',
    correlationId: uuidv4(),
    basketId: order.basketAllocation ? order.basketAllocation.basketId : null,
    clearingHouseId: null,
    csd: null,
    sponsorId: null,
    ignoreClearAxeId: false,
    backToStagingTradingType: null,
    settlementVenue: null,
    fundShortName: null,
    endDateTerm: null,
    endDateTerms: null,
    endDates: null,
    startDateTerm: null
  }
}

export const deriveDefaultTerm = (startDate: Date | null, endDate: Date | null, term: OrderTerm | null) => {
  return isNotNil(startDate) && isNil(endDate) ? OrderTerm.CUSTOM_O : isNotNil(startDate) || isNotNil(endDate) ? OrderTerm.CUSTOM : term
}

export const createRepeatedTermsFilter = (term: OrderTerm | null) => (orderDetail: OrderDetail) =>
  isNil(term) || orderDetail.order.term !== term

export const createPreparingOrdersFilter = (preparedOrderIds: string[]) => (orderDetail: OrderDetail) =>
  !preparedOrderIds.includes(orderDetail.order.orderId)

export const bulkDateUpdateDialogArgs = {
  type: NotificationType.Confirm,
  title: Translation.TC_BULK_DATE,
  message: Translation.SC_BULK_DATE_UPDATE_CONFIRMATION,
  buttons: [Translation.TC_BUTTON_YES, Translation.TC_BUTTON_NO],
  cancelButton: Translation.TC_BUTTON_NO,
  defaultButton: Translation.TC_BUTTON_YES
}
